import {StoreAreas, VerifyVoucherResponse} from 'types';
import {MembershipCard} from 'types/membership';

export type AppState = {
  defaultMembershipCard: MembershipCard | null | undefined;
  membershipCards: MembershipCard[];
  voucherData: VerifyVoucherResponse | undefined;
  currentStore?: CurrentStoreType | undefined;
  locations: StoreAreas[] | null;
  isDirectCheckout: boolean;
  accessTradeClickId: string | undefined;
  pricezaClickId: string | undefined;
  isAppLoading: boolean;
  appMode: AppMode;
  appVersion: string | undefined;
  deviceOS: string | undefined;
  resetEffectValue: number;
  isFromBasketNotification: boolean;
};

export type CurrentStoreType = {
  zipcode: string;
  subdistrict: string;
  storeCodes: string[];
  showStorePickup: boolean;
  isSameDayDelivery: boolean | undefined;
  addressId?: string;
};

export enum AffiliateProgramType {
  ACCESSTRADE = 'ACCESSTRADE',
  PRICEZA = 'PRICEZA'
}

export enum AppMode {
  regular = 'regular',
  express = 'express'
}
